<template>
	<div class="space-y-1">
		<label class="block text-sm font-medium text-gray-700">{{ label }}</label>
		<div class="gap-2 flex items-center">
			<button
				v-for="typeOption in sectionTypeOptions"
				:key="typeOption.value"
				@click="updateValue(typeOption.value)"
				class="px-3 py-2 rounded-md cursor-pointer transition-all duration-200 text-sm font-medium outline outline-2 outline-offset-2"
				:class="modelValue === typeOption.value ? 'outline-black' : 'bg-white text-gray-700 outline-white/0 hover:outline-black/20 hover:bg-gray-50'"
			>
				{{ typeOption.label }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SectionTypeFilter',
	props: {
		modelValue: {
			type: String,
			default: 'section'
		},
		label: {
			type: String,
			default: 'Section Type'
		}
	},
	emits: ['update:modelValue'],
	data() {
		return {
			sectionTypeOptions: [
				{ label: 'Section', value: 'section' },
				{ label: 'Home & land', value: 'homeLand' },
			]
		}
	},
	methods: {
		updateValue(value) {
			this.$emit('update:modelValue', value)
		}
	}
}
</script>